import moment from "moment";

const MIN_DATE_PARTS = 3;

/**
 * Builds a moment from a Java LocalDate/LocalDateTime serialised as a numeric
 * array: [year, month, day, hour, minute, second, nano]. Jackson omits trailing
 * zero components, so 15:30:00 arrives as [year, month, day, 15, 30] — only
 * year, month and day are guaranteed present.
 */
export const createDateFromArray = (dateArray) => {
  if (!Array.isArray(dateArray) || dateArray.length < MIN_DATE_PARTS) {
    throw new Error("Invalid date array");
  }

  const [year, month, day, hour = 0, minute = 0] = dateArray;

  const date = moment([year, month - 1, day, hour, minute]);

  return date;
};
